import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'app-confirm-email-sent-modal',
	templateUrl: './confirm-email-sent-modal.component.html',
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmEmailSentModalComponent {}
